@import '../ui-cms-contact-channels';

ui-cms-contact-channels-phone {
  display: block;

  @include channel_contactbox();

  .phone {
    @extend %headlineH3;
  }

  time {
    font-weight: $font-weight-bold;
  }
}
